/**
 * OrderCard Component
 * 
 * Displays order summary in the available orders list
 */

import { Order } from '@/store/orders';
import { formatCurrency, formatDistance } from '@/lib/utils';

interface OrderCardProps {
  order: Order;
  onPress: () => void;
}

export default function OrderCard({ order, onPress }: OrderCardProps) {
  const deliveryFeeFormatted = formatCurrency(order.deliveryFee);
  const totalAmountFormatted = formatCurrency(order.totalAmount);
  const distanceFormatted = formatDistance(order.distance);

  return (
    <div
      onClick={onPress}
      className="bg-card border rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer active:scale-[0.98]"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-semibold text-lg">{order.vendor.name}</h3>
          <p className="text-sm text-muted-foreground">
            {order.vendor.address}
          </p>
        </div>
        <div className="text-right">
          <div className="text-lg font-bold text-primary">
            {deliveryFeeFormatted}
          </div>
          <div className="text-xs text-muted-foreground">
            {distanceFormatted}
          </div>
        </div>
      </div>

      {/* Items Summary */}
      <div className="mb-3 text-sm">
        <div className="text-muted-foreground">
          Order Total: {totalAmountFormatted}
        </div>
      </div>

      {/* Delivery Address */}
      <div className="mb-3">
        <div className="text-sm font-medium">Delivery to:</div>
        <div className="text-sm text-muted-foreground">
          {order.delivery.address}
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between pt-3 border-t">
        <div className="flex items-center gap-2">
          <div className={`px-2 py-1 rounded text-xs font-medium ${
            order.paymentMethod === 'cod' 
              ? 'bg-orange-100 text-orange-700' 
              : 'bg-blue-100 text-blue-700'
          }`}>
            {order.paymentMethod.toUpperCase()}
          </div>
        </div>
        <button
          className="px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onPress();
          }}
        >
          View Details
        </button>
      </div>
    </div>
  );
}










